/**
 * Valores de role (profile) do usuário.
 * Centraliza as strings para evitar uso solto em todo o código.
 */
export const ROLES = {
	user: "user",
	admin: "admin",
	master: "master",
};
